import { render, staticRenderFns } from "./HomeHotEvent.vue?vue&type=template&id=ab2d528c&scoped=true"
import script from "./HomeHotEvent.vue?vue&type=script&lang=js"
export * from "./HomeHotEvent.vue?vue&type=script&lang=js"
import style0 from "./HomeHotEvent.vue?vue&type=style&index=0&id=ab2d528c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2d528c",
  null
  
)

export default component.exports